import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d174b27"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  is: "div",
  class: "relative rounded-none relative dark:border-gray-600 dark:border-0 space-y-2 category-list scrollbar"
}
const _hoisted_2 = { class: "flex justify-between w-full focus:outline-none focus-visible:outline-black dark:focus-visible:outline-white" }
const _hoisted_3 = { class: "mb-0 normal-case" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}

import CategoryBox from "@/Components/FAQCategories/CategoryBox.vue";
import {PropType, ref, toRef,} from "vue";
import Category from "@/types/Category";
import Card from "@/Components/General/Card.vue";
import {mdiChevronDown} from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";
import TextButton from "@/Components/Buttons/TextButton.vue";
import FaqCategory from "@/types/FaqCategory";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryList',
  props: {
  categories: {
    type: Array as PropType<FaqCategory[]>,
    required: true,
  },
  selectedCategory: {
    type: Object as PropType<FaqCategory | null | undefined>,
    required: false,
  },
},
  emits: ["selectCategory"],
  setup(__props, { emit }) {

const props = __props;




const selectedCategory = toRef(props, "selectedCategory");
const expanded = ref<any>([selectedCategory.value?.parent_id ? Number(selectedCategory.value?.parent_id) : selectedCategory.value?.id]);
const isExpanded = (category: FaqCategory) => {
// check if expanded contains any selected sub categories
  return expanded.value.includes(category.id);
};
const toggleExpansion = (parent: FaqCategory) => {
  if (isExpanded(parent)) {

    expanded.value = expanded.value.filter((number: any) => number !== Number(parent.id))
  } else {
    expanded.value.push(parent.id)
  }
};

const selectCategory = (category: FaqCategory) => {
  emit("selectCategory", category);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (parent) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(TextButton, {
          onClick: _withModifiers((event)=>selectCategory(parent), ["stop"]),
          color: "black",
          class: "w-full pl-2 border border-gray-200 dark:border-gray-600"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(parent.title), 1),
              (parent.expandable != false)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["transition-transform", isExpanded(parent) ? ' transform rotate-180' : ''])
                  }, [
                    _createVNode(_unref(SvgIcon), {
                      onClick: _withModifiers(($event: any) => (toggleExpansion(parent)), ["stop"]),
                      onKeyup: _withKeys(($event: any) => (toggleExpansion(parent)), ["enter"]),
                      type: "mdi",
                      path: _unref(mdiChevronDown)
                    }, null, 8, ["onClick", "onKeyup", "path"])
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(CollapseTransition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              class: "py-2 space-y-2"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parent.sub_categories, (category) => {
                return (_openBlock(), _createBlock(CategoryBox, {
                  category: category,
                  selected: category.id === selectedCategory.value?.id ,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  onSelectCategory: ($event: any) => (selectCategory(category)),
                  selectedCategory: selectedCategory.value,
                  "return-selected": true
                }, null, 8, ["category", "selected", "onSelectCategory", "selectedCategory"]))
              }), 256)),
              (parent.sub_categories?.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Ingen under categorier"))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, isExpanded(parent)]
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 256))
  ]))
}
}

})